import React, { Fragment, useEffect } from 'react';
import { func, instanceOf, number, string } from 'prop-types';
import { connect } from 'react-redux';

import SurveyNameForm from '../SurveyNameForm';
import TargettingCriteria from './TargettingCriteria';
import {
  getTargettingCriteria,
  handleCreateSurvey,
} from '../../../actions/turnkeyOmnibusActions';

const SurveyTarget = ({
  handleBack,
  handleNext,
  getTargettingCriteria,
  study,
  tcSti,
  surveyName,
  incidenceRate,
  requiredCompletes,
  ir_ss_data,
  handleCreateSurvey,
}) => {
  useEffect(() => {
    if (study.sti !== tcSti) {
      getTargettingCriteria(study.sti);
    }
  }, []);

  const validate = a => {
    const re = /^[a-zA-Z0-9 ]*$/;
    return re.test(a);
  };

  const _isButtonEnable = () => {
    if (ir_ss_data.loading || ir_ss_data.error) {
      return true;
    }
    const isValid = validate(surveyName.trim());
    const isValidIr = incidenceRate >= 20;
    const isValidSampleSize = requiredCompletes >= 1000;
    const isDisaled = surveyName && isValid && isValidIr && isValidSampleSize;
    return !isDisaled;
  };

  const _hanldeNextclick = () => {
    handleCreateSurvey(true).then(res => {
      if (res && res.gizmoSurveyId) {
        handleNext();
      }
    });
  };

  return (
    <Fragment>
      <div className="ie--steps--body ie--target">
        <SurveyNameForm />
        <TargettingCriteria />
        <div className="ie--target--text-default">* Default Criteria.</div>
      </div>
      <footer className="ie--steps--footer">
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={handleBack}
        >
          Back
        </button>
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={_hanldeNextclick}
          disabled={_isButtonEnable()}
        >
          Save &amp; Continue
        </button>
      </footer>
    </Fragment>
  );
};

SurveyTarget.propTypes = {
  handleNext: func.isRequired,
  handleBack: func.isRequired,
  getTargettingCriteria: func.isRequired,
  study: instanceOf(Object),
  tcSti: number,
  incidenceRate: number,
  requiredCompletes: number,
  surveyName: string.isRequired,
  ir_ss_data: instanceOf(Object),
  handleCreateSurvey: func.isRequired,
};

SurveyTarget.defaultProps = {
  study: {
    pn: null,
    sti: null,
    sd: '',
  },
  tcSti: null,
  incidenceRate: null,
  requiredCompletes: null,
  ir_ss_data: {
    loading: true,
    error: false,
  },
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { surveyInfo, targetingCriteria, ir_ss_data } = turnkeyOmnibus;
  return {
    study: surveyInfo.study,
    requiredCompletes: surveyInfo.requiredCompletes,
    incidenceRate: surveyInfo.incidenceRate,
    surveyName: surveyInfo.surveyName,
    tcSti: targetingCriteria.sti,
    ir_ss_data,
  };
};

export default connect(
  mapStateToProps,
  { getTargettingCriteria, handleCreateSurvey }
)(SurveyTarget);
